// extracted by mini-css-extract-plugin
export default {"root":"Power_root__vuyMc","title":"Power_title__A5nP3","count":"Power_count__ilM82"};